/**
 * The Orbit mark: a batter at the moment of contact, inside the ball's orbit.
 * Colours are pinned rather than inherited — the previous app passed them as
 * props and the login screen rendered the inverse of the header.
 */
export function Mark({ size = 26 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true"
         style={{ display: "block", overflow: "visible" }}>
      <path d="M85.67 38.42 A37.5 37.5 0 1 1 74.1 21.27"
            fill="none" stroke="#E9A13B" strokeWidth="3.54" strokeLinecap="round" />
      <g stroke="#F2EFE6" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <line x1="42.71" y1="40.1" x2="45.83" y2="55.21" strokeWidth="7.92" />
        <line x1="45.83" y1="55.21" x2="55.21" y2="60.94" strokeWidth="6.88" />
        <line x1="55.21" y1="60.94" x2="61.98" y2="69.79" strokeWidth="6.88" />
        <line x1="45.83" y1="55.21" x2="39.58" y2="63.02" strokeWidth="6.88" />
        <line x1="39.58" y1="63.02" x2="33.85" y2="70.31" strokeWidth="6.88" />
        <line x1="43.75" y1="41.67" x2="54.17" y2="42.71" strokeWidth="6.04" />
      </g>
      <circle cx="42.71" cy="31.25" r="6.15" fill="#F2EFE6" />
      <g fill="#F2EFE6">
        <path d="M51.98 45.42 L58.54 41.67 L56.67 38.33 L50.1 42.08 Z" />
        <path d="M59.69 43.65 L75 34.9 L70.83 27.6 L55.52 36.35 Z" />
      </g>
      <circle cx="81.09" cy="29.03" r="5.42" fill="#CE4137" />
    </svg>
  );
}
